import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const FAQS = [
  {
    q: "What does the Zentra bar taste like?",
    a: "A rich choco-nut flavour — think a proper chocolate-nut snack, not a 'health food' taste. The horse gram microgreens are dried and milled fine, so you get all the nutrition without any grassy aftertaste.",
  },
  {
    q: "What's inside the bar?",
    a: "Quality protein, dates, nuts and seeds — plus 2 g of horse gram microgreens we grow ourselves at our indoor farm in Coimbatore. No added sugar, trans-fat free, and a clean ingredient list you can read in one glance.",
  },
  {
    q: "Does it contain allergens?",
    a: "Yes. The bar contains nuts and seeds, and it's made in a facility that also handles nuts, soy, dairy and gluten. If you have a food allergy, please check the ingredient list on the pack or message us before ordering.",
  },
  {
    q: "How long does a bar stay fresh?",
    a: "6 months from the date of manufacture. Store your bars in a cool, dry place away from direct sunlight — no refrigeration needed.",
  },
  {
    q: "Where do you deliver, and what does shipping cost?",
    a: "We ship across India. Shipping is a flat ₹49, and free on orders of ₹500 and above. Once your order is dispatched, you can follow it live on our Track Order page.",
  },
  {
    q: "How can I pay?",
    a: "UPI, cards, net banking and wallets through our secure PayU checkout — or choose Cash on Delivery and pay when your bars arrive.",
  },
  {
    q: "What's your return policy?",
    a: "Since our bars are food products, we can't take back opened packs. If your order arrives damaged or you receive the wrong item, message us within 48 hours with photos and we'll replace it or refund you — full details on our Refund Policy page.",
  },
];

const Faq = () => (
  <section id="faq" data-testid="faq-section" className="border-t border-white/10 py-24 lg:py-32">
    <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-12">
      <Reveal className="lg:col-span-4">
        <p className="mb-4 text-xs font-medium uppercase tracking-[0.25em] text-[#7ED321]">FAQ</p>
        <h2 className="font-display text-4xl uppercase leading-[0.95] text-white sm:text-5xl">
          Questions, <span className="text-outline">answered</span>
        </h2>
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#A6A66A]">
          Taste, ingredients, delivery, payment — everything shoppers ask us before ordering.
          Something missing? Ask us on WhatsApp.
        </p>
      </Reveal>

      <Reveal delay={0.15} className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-white/10"
              data-testid={`faq-item-${i + 1}`}
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i + 1}`}
                className="py-6 text-left font-display text-lg uppercase tracking-wide text-white transition-colors duration-300 hover:text-[#7ED321] hover:no-underline lg:text-xl"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-sm leading-relaxed text-[#A6A66A]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
